var map = {
	"./a.png": 218,
	"./accordion-ic.svg": 8480,
	"./career-bg.png": 7585,
	"./covenlabs-about-bg.png": 8936,
	"./covenlabs-bg.jpg": 6684,
	"./covenlabsclub-bg.jpg": 9116,
	"./ecosystem-poster-mobile.jpg": 7490,
	"./ecosystem-poster.jpg": 9101,
	"./fund-round.png": 1193,
	"./ic-arrow-select.svg": 9400,
	"./ic-arrow.svg": 3815,
	"./ic-brand-positioning.png": 5367,
	"./ic-brand-positioning@2x.png": 745,
	"./ic-cefi-integration.png": 172,
	"./ic-cefi-integration@2x.png": 7308,
	"./ic-community.png": 3515,
	"./ic-community@2x.png": 4741,
	"./ic-content-community-building.png": 4594,
	"./ic-content-community-building@2x.png": 2546,
	"./ic-development.png": 5215,
	"./ic-development@2x.png": 8769,
	"./ic-discord.svg": 8124,
	"./ic-fintech-integration.png": 3542,
	"./ic-fintech-integration@2x.png": 3470,
	"./ic-gamification.png": 97,
	"./ic-gamification@2x.png": 4227,
	"./ic-instagram.svg": 8680,
	"./ic-launch-strategy.png": 9381,
	"./ic-launch-strategy@2x.png": 2159,
	"./ic-linkedin.svg": 6466,
	"./ic-loyalty.png": 322,
	"./ic-loyalty@2x.png": 7170,
	"./ic-medium.svg": 3025,
	"./ic-modal-success.png": 4213,
	"./ic-nft-creation.png": 3716,
	"./ic-nft-creation@2x.png": 5620,
	"./ic-point-tokenomics.png": 2327,
	"./ic-point-tokenomics@2x.png": 8857,
	"./ic-progress1.png": 6722,
	"./ic-progress2.png": 729,
	"./ic-progress3.png": 4976,
	"./ic-progress4.png": 7199,
	"./ic-progress5.png": 2102,
	"./ic-right-arrow.svg": 2934,
	"./ic-shared-economy.png": 1634,
	"./ic-shared-economy@2x.png": 1138,
	"./ic-telegram.svg": 2749,
	"./ic-tokenomics.png": 5588,
	"./ic-tokenomics@2x.png": 2676,
	"./ic-twitter.svg": 6449,
	"./ic-web3-strategy.png": 3665,
	"./ic-web3-strategy@2x.png": 195,
	"./icon-slide-right.svg": 5685,
	"./invest-form-bg.png": 7997,
	"./language-border-mobile.svg": 8359,
	"./language-border.svg": 1060,
	"./loader.svg": 5586,
	"./logo-benofity.svg": 9043,
	"./logo-blockchain.svg": 889,
	"./logo-budyboo.svg": 2235,
	"./logo-covenlabsclub.svg": 3040,
	"./logo-definx.svg": 2063,
	"./logo-looyti.svg": 9233,
	"./logo-obaven.svg": 1408,
	"./logo-watchers-coven.svg": 9246,
	"./logo-winaged.svg": 6299,
	"./logo.png": 2806,
	"./logo@2x.png": 4910,
	"./media-bg.jpg": 1911,
	"./news-aa.jpg": 5287,
	"./news-aksam.jpg": 7556,
	"./news-anka.jpg": 3512,
	"./news-cointrust.jpg": 8118,
	"./news-gearrice.jpg": 8647,
	"./news-iha.jpg": 7861,
	"./news-posta.jpg": 1638,
	"./our-projects-bg.jpg": 5832,
	"./press-release-1.jpg": 4448,
	"./press-release-1@2x.jpg": 7712,
	"./round-deneme.png": 8290,
	"./waitlist-form-bg.png": 5741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;